import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from '../Store/Store'

export interface BlogRequest {
  id?:number,
  title:string,
  body?:string
  image?:string,
  status?:string,
  tags?:string,
  excerpt?:string,
  cat_id:number | null
}
export interface BlogResponse {
  id?:number,
  title:string,
  body?:string
  image?:string,
  status?:string,
  tags?:string,
  excerpt?:string,
  cat_id:number | null
}

export const blogApi = createApi({
  reducerPath: 'blogApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/blog',
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  tagTypes: ['blog','categories'],

  endpoints: (builder) => ({
    getBlogCats: builder.query({
      query: () => '/categories/all',
      providesTags: ['categories']
    }),
    getBlogs: builder.query({
      query: () => 'all',
      providesTags: ['blog']
    }),
    getPost: builder.query({
      query: (id) => `/${id}`,
      providesTags: ['blog']
    }),
    createPost: builder.mutation<BlogResponse, BlogRequest>({
      query: (data) => ({
        url: '/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['blog']
    }),
    updatePost: builder.mutation<BlogResponse, Partial<BlogRequest> & Pick<BlogRequest, 'id'>>({
      query: ({ id, ...patch }) => ({
        url: `/${id}`,
        method: 'PATCH',
        body: patch,
      }),
      invalidatesTags: ['blog']
    }),
    deletePost: builder.mutation<boolean, number>({
      query: (id) => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['blog']
    }),
  }),
})

export const {useGetBlogCatsQuery, useGetBlogsQuery, useGetPostQuery , useCreatePostMutation, useUpdatePostMutation, useDeletePostMutation} = blogApi